import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from "react";
import { useIntl } from "react-intl";
import { Chip, DropdownSelect, Icon } from "@components/atoms";
import * as S from "./styles";
export var ProductListHeader = function ProductListHeader(_ref) {
  var _ref$numberOfProducts = _ref.numberOfProducts,
      numberOfProducts = _ref$numberOfProducts === void 0 ? 0 : _ref$numberOfProducts,
      openFiltersMenu = _ref.openFiltersMenu,
      clearFilters = _ref.clearFilters,
      activeSortOption = _ref.activeSortOption,
      _ref$activeFilters = _ref.activeFilters,
      activeFilters = _ref$activeFilters === void 0 ? 0 : _ref$activeFilters,
      _ref$activeFiltersAtt = _ref.activeFiltersAttributes,
      activeFiltersAttributes = _ref$activeFiltersAtt === void 0 ? [] : _ref$activeFiltersAtt,
      sortOptions = _ref.sortOptions,
      onChange = _ref.onChange,
      onCloseFilterAttribute = _ref.onCloseFilterAttribute;
  var intl = useIntl();
  return React.createElement(S.Wrapper, null, React.createElement(S.Bar, null, React.createElement(S.LeftSide, null, React.createElement(S.FiltersButton, {
    onClick: openFiltersMenu,
    "data-cy": "filters__button"
  }, React.createElement(Icon, {
    name: "filter",
    size: 24
  }), React.createElement(S.Filters, null, intl.formatMessage(_defineProperty({
    defaultMessage: "FILTERS",
    "id": "@next.components.molecules.ProductListHeader.ProductListHeader.406136781"
  }, "id", "@next.components.molecules.ProductListHeader.ProductListHeader.406136781")), activeFilters > 0 && React.createElement(React.Fragment, null, React.createElement("span", null, "(", activeFilters, ")")))), activeFilters > 0 && React.createElement(S.Clear, {
    onClick: clearFilters
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "CLEAR FILTERS",
    "id": "@next.components.molecules.ProductListHeader.ProductListHeader.1171036277"
  }, "id", "@next.components.molecules.ProductListHeader.ProductListHeader.1171036277")))), React.createElement(S.RightSide, null, React.createElement(S.Element, {
    "data-cy": "no-of-products-found_label"
  }, React.createElement(S.Label, null, intl.formatMessage(_defineProperty({
    defaultMessage: "Products found:",
    "id": "@next.components.molecules.ProductListHeader.ProductListHeader.3317426832"
  }, "id", "@next.components.molecules.ProductListHeader.ProductListHeader.3317426832"))), numberOfProducts), React.createElement(S.Element, null, React.createElement(S.Sort, null, React.createElement(DropdownSelect, {
    onChange: onChange,
    options: sortOptions,
    value: sortOptions.find(function (option) {
      return option.value === activeSortOption;
    })
  }))))), React.createElement(S.FiltersChipsWrapper, null, activeFiltersAttributes.map(function (_ref2) {
    var attributeSlug = _ref2.attributeSlug,
        valueName = _ref2.valueName,
        valueSlug = _ref2.valueSlug;
    return React.createElement(Chip, {
      onClose: function onClose() {
        return onCloseFilterAttribute(attributeSlug, valueSlug);
      }
    }, valueName);
  })));
};
ProductListHeader.displayName = "ProductListHeader";